import { render, staticRenderFns } from "./BillCollapse.vue?vue&type=template&id=0ab19bbc&scoped=true&"
import script from "./BillCollapse.vue?vue&type=script&lang=ts&"
export * from "./BillCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./BillCollapse.vue?vue&type=style&index=0&id=0ab19bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab19bbc",
  null
  
)

export default component.exports